let isLoaded = false;
let loadPromise: Promise<void> | null = null;

// Function to load the PubSuite script
export const loadPubSuite = (): Promise<void> => {
    if (isLoaded) {
        return Promise.resolve();
    }

    if (loadPromise) {
        return loadPromise;
    }

    loadPromise = new Promise((resolve, reject) => {
        if (window.pubSuite) {
            isLoaded = true;
            resolve();
            return;
        }

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://storage.googleapis.com/kochava-web-assets/ps/v1.3.1/pubsuite.js";
        script.async = true;

        script.onload = () => {
            const productId = "1727626";
            const accessToken = "70981bb9-5190-4f88-88c9-bf7eb0aff3e7";
            window.pubSuite?.startWithProductId(productId, accessToken);
            isLoaded = true;
            resolve();
        };

        script.onerror = () => reject(new Error("Failed to load PubSuite script"));

        document.head.appendChild(script);
    });

    return loadPromise;
};

// Function to send a conversion
export const sendConversion = async (conversionName: string) => {

    await loadPubSuite(); 

    if (window.pubSuite) {
        window.pubSuite.sendConversion(conversionName);
    } else {
        console.warn("PubSuite not loaded yet");
    }
};